<app-insight-cards [cards]="cards"></app-insight-cards>
<mat-divider></mat-divider>
@if (lineData) {
    <app-line-chart [data]="lineData" [height]="400"></app-line-chart>
}
